import axios, {AxiosResponse} from 'axios'

// student Statistics
const studentStatistics = async () => {
  const response = await axios.get('/api/student/statistics')
  return response.data
}

// Get all StudentApplication
const studentApplicationList = async ({params}) => {
  const response = await axios.get('/api/student-application/list', params)
  return response.data
}

// Create new StudentApplication
const studentApplicationCreate = async ({data}) => {
  const response = await axios.post('/api/student-application/store', data)
  return response.data
}

// Get StudentApplication by id
const studentApplicationEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`api/student-application/edit/${id}`)
  return response.data
}

// Delete StudentApplication
const studentApplicationDelete = async (id: string) => {
  await axios.get(`/api/student-application/destroy/${id}`)
}

// const studentApplicationToggleArchive
const studentApplicationToggleArchive = async (id: string) => {
  await axios.get(`/api/student-application/toggle-archive/${id}`)
}

// studentApplicationArchiveList
const studentApplicationArchiveList = async ({params}) => {
  const response = await axios.get('/api/student-application/archived-list', params)
  return response.data
}

// studentApplicationView
const studentApplicationView = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/student-application/view/${id}`)
  return response.data
}

// getProgramPayments
const getProgramPayments = async (id: string) => {
  const res = await axios.get(`/api/student-application/program-payment/${id}`)
  return res.data
}

// studentApplicationLetters
const studentApplicationLetters = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/student-application/letters/${id}`)
  return response.data
}

// appLetterView
const appLetterView = async (id: string) => {
  const res = await axios.get(`/api/student-application/show-letter/${id}`)
  return res.data
}

// Get all Student
const studentList = async ({params}) => {
  const response = await axios.get('/api/student/list', params)
  return response.data
}

// Delete Student
const studentDelete = async (id: string) => {
  await axios.get(`/api/student/destroy/${id}`)
}

// const studentToggleArchive
const studentToggleArchive = async (id: string) => {
  await axios.get(`/api/student/toggle-archive/${id}`)
}

// studentArchiveList
const studentArchiveList = async ({params}) => {
  const response = await axios.get('/api/student/archived-list', params)
  return response.data
}

// studentView
const studentView = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/student/view/${id}`)
  return response.data
}

// update Student
const studentUpdate = async ({data}) => {
  await axios.post('/api/student/update', data)
}

// Get Student by id
const studentEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`api/student/edit/${id}`)
  return response.data
}

// Email to student
const studentEmail = async ({data}) => {
  await axios.post('/api/student/email', data)
}

// Get all studentDocumentList
const studentDocumentList = async (student_id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/student-document/list/${student_id}`)
  return response.data
}

// Create new StudentDocument
const studentDocumentCreate = async ({data}) => {
  await axios.post('/api/student-document/store', data)
}

// Get StudentDocument by id
const studentDocumentEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`api/student-document/edit/${id}`)
  return response.data
}

// Delete StudentDocument
const studentDocumentDelete = async (id: string) => {
  await axios.get(`/api/student-document/destroy/${id}`)
}

// Get all studentNoteList
const studentNoteList = async (student_id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/student-note/list/${student_id}`)
  return response.data
}

// Create new StudentNote
const studentNoteCreate = async ({data}) => {
  await axios.post('/api/student-note/store', data)
}

// Get StudentNote by id
const studentNoteEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`api/student-note/edit/${id}`)
  return response.data
}

// Delete StudentNote
const studentNoteDelete = async (id: string) => {
  await axios.get(`/api/student-note/destroy/${id}`)
}

// Get studentInvoices
const studentInvoices = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`api/student/invoice/${id}`)
  return response.data
}

// ApplicationDetails
const getRegAppEmail = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`api/student-application/get-reg-app-email/${id}`)
  return response.data
}

const ApplicationEmail = async ({data}) => {
  const response = await axios.post('/api/student-application/send-reg-app-email', data)
  return response.data
}

// const letterView = async ({data}) => {
//   const response = await axios.post('/api/student-application-letter/view-letter', data)
//   return response.data
// }

// const letterCreate = async ({data}) => {
//   const response = await axios.post('/api/student-application-letter/create-letter', data)
//   return response.data
// }

// Delete StudentLetter
const letterDelete = async (id: string) => {
  await axios.get(`/api/student-application/destroy-letter/${id}`)
}

const stdLetterDelete = async (id: string) => {
  await axios.get(`/api/student/destroy-letter/${id}`)
}

const studentLetterView = async (id: string) => {
  const response = await axios.get(`/api/student/show-letter/${id}`)
  return response.data
}

const studentLetterCreate = async ({data}) => {
  const response = await axios.post('/api/student/create-letter', data)
  return response.data
}

// studentLetterToggle
const studentLetterToggle = async (id: string) => {
  await axios.get(`/api/letter/toggle-visibility/${id}`)
}

const studentProfile = async () => {
  const response = await axios.get(`api/std/my-profile`)
  return response.data
}

const studentDocuments = async () => {
  const response = await axios.get(`api/std/my-document`)
  return response.data
}
const studentLetters = async () => {
  const response = await axios.get(`api/std/my-letters`)
  return response.data
}

const myVideoLibrary = async () => {
  const response = await axios.get('/api/std/video-library')
  return response.data
}

const myVideoSearch = async (
  type: string,
  program_level: string,
  section: string
): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/std/video-search/${type}/${program_level}/${section}`)
  return response.data
}

const myPublicationList = async () => {
  const response = await axios.get('/api/std/pub-list')
  return response.data
}

// Create publication
const myPublicationCreate = async ({data}) => {
  await axios.post('/api/student/pub-store', data)
}

const pubList = async ({params}) => {
  const response = await axios.get('/api/student/publ-list', params)
  return response.data
}

const myInvoices = async () => {
  const response = await axios.get('/api/std/my-invoices')
  return response.data
}

const studentRegulations = async () => {
  const response = await axios.get('/api/std/regulations')
  return response.data
}

const studentNews = async () => {
  const response = await axios.get('/api/std/my-news')
  return response.data
}

const myCourses = async () => {
  const response = await axios.get('/api/std/my-courses')
  return response.data
}

const myAttendance = async (id: string) => {
  const response = await axios.get(`/api/std/my-attendance/${id}`)
  return response.data
}

const lecturerInfo = async (id: string) => {
  const response = await axios.get(`/api/std/lecturer-info/${id}`)
  return response.data
}

const myTranscript = async () => {
  const response = await axios.get('/api/std/my-transcript')
  return response.data
}

const alumniStudent = async (id: string) => {
  const response = await axios.get(`/api/student/alumni/${id}`)
  return response.data
}

const alumniStudentList = async ({params}) => {
  const response = await axios.get('/api/student/alumni-list', params)
  return response.data
}

const alumniStudentDetails = async (id: string) => {
  const response = await axios.get(`/api/student/alumni-details/${id}`)
  return response.data
}

const studentUpgrade = async ({data}) => {
  const response = await axios.post('/api/student/student-upgrade', data)
  return response.data
}

const submitAssignment = async ({data}) => {
  const response = await axios.post('/api/std/store-assignment', data)
  return response.data
}

const studentTranscriptPrint = async (
  lang: string,
  studentId: string
): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/student/transcript-print/${lang}/${studentId}`)
  return response.data
}

const transcriptPrint = async (lang: string, studentId: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/std/transcript-print/${lang}/${studentId}`)
  return response.data
}

const studentTranscript = async (id: string) => {
  const response = await axios.get(`/api/student/transcript/${id}`)
  return response.data
}

const getCourseEvDetails = async (id: string) => {
  const response = await axios.get(`/api/std/get-course-ev-form/${id}`)
  return response.data
}

const evFormStore = async ({data}) => {
  const response = await axios.post('/api/std/ev-form-store', data)
  return response.data
}

const stdEvalutationFormGraph = async (id: string) => {
  const response = await axios.get(`/api/std/ev-form-graph/${id}`)
  return response.data
}

const annualFeeback = async () => {
  const response = await axios.get('/api/std/annual-form')
  return response.data
}

const getAnnualFeeback = async (id: string) => {
  const response = await axios.get(`/api/std/get-annual-form/${id}`)
  return response.data
}

const storeAnnualForm = async ({data}) => {
  const response = await axios.post('/api/std/annual-form-store', data)
  return response.data
}

const createAppLetter = async ({data}) => {
  const response = await axios.post('/api/student-application/create-letter', data)
  return response.data
}

const moveAppToStd = async ({data}) => {
  const response = await axios.post('/api/student-application/move-app-to-stds', data)
  return response.data
}

const getAppList = async () => {
  const response = await axios.get(`/api/student-application/get-app-list`)
  return response.data
}

const getStdList = async () => {
  const response = await axios.get(`/api/student/get-students`)
  return response.data
}

const createUserForStds = async ({data}) => {
  const response = await axios.post('/api/student/create-user', data)
  return response.data
}

const skipEvForm = async (id: string) => {
  const response = await axios.get(`/api/std/skip-evaluation-form/${id}`)
  return response.data
}

const applicationLetterEmail = async (id: string) => {
  const response = await axios.get(`/api/student-application/email-app-letter/${id}`)
  return response.data
}

const studentLetterEmail = async (id: string) => {
  const response = await axios.get(`/api/student/email-letter/${id}`)
  return response.data
}

const importExcelStudents = async ({data}) => {
  const response = await axios.post('/api/student-application/import-excel', data)
  return response.data
}

const aYAndIntake = async () => {
  const response = await axios.get(`/api/student-application/ay-intakes`)
  return response.data
}

const createGroupLetter = async ({data}) => {
  const response = await axios.post('/api/student-application/create-group-letter', data)
  return response.data
}

const relatedPrograms = async (
  academic_year_id: string,
  intake_id: string
): Promise<AxiosResponse<any>> => {
  const response = await axios.get(
    `/api/student-application/related-programs/${academic_year_id}/${intake_id}`
  )
  return response.data
}

const stdRelatedPrograms = async (
  academic_year_id: string,
  intake_id: string
): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/student/related-programs/${academic_year_id}/${intake_id}`)
  return response.data
}

const relatedApplications = async ({data}) => {
  const response = await axios.post('/api/student-application/related-applications', data)
  return response.data
}

const updateAndEmailStdAccount = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/student/update-email-account/${id}`)
  return response.data
}

const relatedStudents = async ({data}) => {
  const response = await axios.post('/api/student/related-students', data)
  return response.data
}

const createGroupLetterStd = async ({data}) => {
  const response = await axios.post('/api/student/create-group-letter', data)
  return response.data
}

const editStdProfile = async () => {
  const response = await axios.get('/api/std/edit-profile')
  return response.data
}

const updateStdProfile = async ({data}) => {
  const response = await axios.post('/api/std/udpate-profile', data)
  return response.data
}

const onlineApplications = async ({params}) => {
  const response = await axios.get('/api/student-application/online-applications', params)
  return response.data
}

const onlineApplicationDelete = async (id: string) => {
  await axios.get(`/api/student-application/online-app-destroy/${id}`)
}

const onlineApplication = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/student-application/online-app/${id}`)
  return response.data
}

const changeOnlineApp = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`api/student-application/change-to-app/${id}`)
  return response.data
}

const changeOnlineApplication = async ({data}) => {
  const response = await axios.post('/api/student-application/change-to-application', data)
  return response.data
}

const studentCardList = async (id: string) => {
  const response = await axios.get(`/api/std-card/list/${id}`)
  return response.data
}

// Create new studentCard
const studentCardCreate = async ({data}) => {
  const response = await axios.post('/api/std-card/store', data)
  return response.data
}

// Get studentCard by id
const studentCardEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`api/std-card/edit/${id}`)
  return response.data
}

// Delete studentCard
const studentCardDelete = async (id: string) => {
  await axios.get(`/api/std-card/destroy/${id}`)
}

// const studentCardToggleArchive
const studentCardInactive = async (id: string) => {
  await axios.get(`/api/std-card/inactive/${id}`)
}

const studentService = {
  studentCardList,
  studentCardCreate,
  studentCardEdit,
  studentCardDelete,
  studentCardInactive,
  changeOnlineApplication,
  changeOnlineApp,
  onlineApplication,
  onlineApplications,
  onlineApplicationDelete,
  stdRelatedPrograms,
  updateStdProfile,
  editStdProfile,
  createGroupLetterStd,
  relatedStudents,
  updateAndEmailStdAccount,
  relatedApplications,
  relatedPrograms,
  createGroupLetter,
  aYAndIntake,
  importExcelStudents,
  studentLetterEmail,
  applicationLetterEmail,
  skipEvForm,
  createUserForStds,
  getStdList,
  stdLetterDelete,
  getAppList,
  moveAppToStd,
  createAppLetter,
  studentStatistics,
  storeAnnualForm,
  annualFeeback,
  getAnnualFeeback,
  stdEvalutationFormGraph,
  evFormStore,
  getCourseEvDetails,
  studentTranscriptPrint,
  studentTranscript,
  transcriptPrint,
  submitAssignment,
  studentUpgrade,
  alumniStudentDetails,
  alumniStudentList,
  alumniStudent,
  myTranscript,
  lecturerInfo,
  myAttendance,
  myCourses,
  studentNews,
  studentRegulations,
  myInvoices,
  pubList,
  myPublicationList,
  myPublicationCreate,
  myVideoLibrary,
  myVideoSearch,
  studentLetters,
  studentDocuments,
  studentProfile,
  studentLetterView,
  studentLetterCreate,
  studentLetterToggle,
  studentApplicationList,
  studentApplicationCreate,
  studentApplicationEdit,
  studentApplicationDelete,
  getProgramPayments,
  studentApplicationToggleArchive,
  studentApplicationArchiveList,
  studentApplicationView,
  studentApplicationLetters,
  appLetterView,
  studentList,
  studentDelete,
  studentToggleArchive,
  studentArchiveList,
  studentView,
  studentUpdate,
  studentEdit,
  studentEmail,
  studentDocumentList,
  studentDocumentCreate,
  studentDocumentEdit,
  studentDocumentDelete,
  studentNoteList,
  studentNoteCreate,
  studentNoteEdit,
  studentNoteDelete,
  studentInvoices,
  getRegAppEmail,
  ApplicationEmail,
  // letterView,
  // letterCreate,
  letterDelete,
}

export default studentService
